<template>
  <div>
    <v-container>
      <v-layout wrap class="mb-2">
        <v-flex xs9>
          <h2>{{ $t('Profile') }}</h2>
        </v-flex>
        <v-flex xs3 class="text-xs-right">
          <v-btn fab outline small color="primary" @click="isEditShop = true" v-if="!isEditShop">
            <v-icon>edit</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <shop-profile
        :isEdit="isEditShop"
        :showAddress="true"
        @onSave="isEditShop = false"
      ></shop-profile>
    </v-container>
    <v-divider></v-divider>
  </div>
</template>

<script>
import ShopProfile from '@/components/view/setting/ecommerce/ShopProfile'
export default {
  data() {
    return {
      isEditShop: false
    }
  },
  components: { ShopProfile }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/ShopProfilePage.vue